'use strict'

module.exports = {
    CLOSE_METHODS: {
        MOUSE_OUT: 'mouseOut',
        OUTER_CLICK: 'outerClick',
        MANUAL: 'manual'
    }
}